import React, { useState } from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../../API/auth";
import { Splash } from "../../../Layout";
import LoginForm from "./LoginForm";

export default function LoginPage(): React.ReactNode {
  const auth = useAuth();
  const [error, setError] = useState<Error | null>(null);

  if (auth.username) {
    return <Navigate to="/" />;
  }
  return (
    <Splash>
      <LoginForm
        onLogin={async (credentials) => {
          setError(await auth.login(credentials));
        }}
        error={error}
      />
    </Splash>
  );
}
